/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let FormulaElementType = /*#__PURE__*/function (FormulaElementType) {
  FormulaElementType["OPERATOR_ADD"] = "+";
  FormulaElementType["OPERATOR_SUBTRACT"] = "-";
  FormulaElementType["OPERATOR_MULTIPLY"] = "x";
  FormulaElementType["OPERATOR_DIVIDE"] = "/";
  FormulaElementType["VALUE_NODE"] = "VALUE_NODE";
  FormulaElementType["PAREN_LEFT"] = "(";
  FormulaElementType["PAREN_RIGHT"] = ")";
  FormulaElementType["POTENTIAL_PLACEHOLDER"] = "POTENTIAL_PLACEHOLDER";
  return FormulaElementType;
}({});
//# sourceMappingURL=FormulaElementType.js.map
